import React, { FC } from 'react';

import { AccordionProps } from '../models';
import { AccordionItem } from './accordion-item';

interface AccordionWrapperProps extends AccordionProps {
  selectedIndex: number[];
  handleTogglerAccordionItem: (index: number) => () => void;
}

export const AccordionWrapper: FC<AccordionWrapperProps> = ({
  items,
  semanticVariant: Tag,
  headlineTag,
  openIcon,
  closeIcon,
  selectedIndex,
  handleTogglerAccordionItem,
}) => (
  <Tag>
    {items.map(({ title, children, ...rest }, index) => (
      <AccordionItem
        title={title}
        semanticVariant={Tag}
        indexValue={index}
        itemsLength={items.length}
        isOpen={selectedIndex.some((i: number) => i === index)}
        headlineTag={headlineTag}
        openIcon={openIcon}
        closeIcon={closeIcon}
        handleTogglerAccordionItem={handleTogglerAccordionItem(index)}
        // eslint-disable-next-line react/no-array-index-key
        key={title + index}
        tabIndex={0}
        {...rest}
      >
        {children}
      </AccordionItem>
    ))}
  </Tag>
);
